import {
  LikeAudienceDataCachedReportAction,
  LikeAudienceDataNewReportAction,
  UserAction
} from 'modules/tracking/types/user-actions';

export const isLikeAudienceDataCachedReportAction = (
  action?: UserAction
): action is LikeAudienceDataCachedReportAction => (
  action !== undefined
  && action.eventCategory === 'like audience data'
  && action.eventAction === 'cached-report'
);

export const isLikeAudienceDataNewReportAction = (
  action?: UserAction
): action is LikeAudienceDataNewReportAction => (
  action !== undefined
  && action.eventCategory === 'like audience data'
  && action.eventAction === 'new-report'
);
